export const translations = {
    en: {
      planDetailsHeader: 'Plan Details',
      planType: 'Plan Type',
      dailyLimit: 'Daily Limit',
      maxFileSize: 'Maximum File Size',
      availableStorage: 'Available Storage',
      storageUsed: 'Storage Used',
      uploadsRemaining: 'Uploads Remaining',
      unlimited: 'Unlimited',
      of: 'of',
      unavailable: 'Unavailable',
    },
    pt: {
      planDetailsHeader: 'Detalhes do Plano',
      planType: 'Tipo de Plano',
      dailyLimit: 'Limite Diário',
      maxFileSize: 'Tamanho Máximo por Arquivo',
      availableStorage: 'Armazenamento Disponível',
      storageUsed: 'Armazenamento Usado',
      uploadsRemaining: 'Uploads Restantes',
      unlimited: 'Ilimitado',
      of: 'de',
      unavailable: 'Indisponível',
    },
    es: {
      planDetailsHeader: 'Detalles del Plan',
      planType: 'Tipo de Plan',
      dailyLimit: 'Límite Diario',
      maxFileSize: 'Tamaño Máximo por Archivo',
      availableStorage: 'Almacenamiento Disponible',
      storageUsed: 'Almacenamiento Usado',
      uploadsRemaining: 'Subidas Restantes',
      unlimited: 'Ilimitado',
      of: 'de',
      unavailable: 'No Disponible',
    },
    fr: {
      planDetailsHeader: 'Détails du Plan',
      planType: 'Type de Plan',
      dailyLimit: 'Limite Quotidienne',
      maxFileSize: 'Taille Maximale du Fichier',
      availableStorage: 'Stockage Disponible',
      storageUsed: 'Stockage Utilisé',
      uploadsRemaining: 'Téléversements Restants',
      unlimited: 'Illimité',
      of: 'de',
      unavailable: 'Indisponible',
    },
    de: {
      planDetailsHeader: 'Plandetails',
      planType: 'Plantyp',
      dailyLimit: 'Tägliches Limit',
      maxFileSize: 'Maximale Dateigröße',
      availableStorage: 'Verfügbarer Speicherplatz',
      storageUsed: 'Verwendeter Speicherplatz',
      uploadsRemaining: 'Verbleibende Uploads',
      unlimited: 'Unbegrenzt',
      of: 'von',
      unavailable: 'Nicht Verfügbar',
    },
    it: {
      planDetailsHeader: 'Dettagli del Piano',
      planType: 'Tipo di Piano',
      dailyLimit: 'Limite Giornaliero',
      maxFileSize: 'Dimensione Massima del File',
      availableStorage: 'Archiviazione Disponibile',
      storageUsed: 'Archiviazione Utilizzata',
      uploadsRemaining: 'Caricamenti Rimanenti',
      unlimited: 'Illimitato',
      of: 'di',
      unavailable: 'Non Disponibile',
    },
    ru: {
      planDetailsHeader: 'Детали плана',
      planType: 'Тип плана',
      dailyLimit: 'Дневной лимит',
      maxFileSize: 'Максимальный размер файла',
      availableStorage: 'Доступное хранилище',
      storageUsed: 'Используемое хранилище',
      uploadsRemaining: 'Оставшиеся загрузки',
      unlimited: 'Неограниченно',
      of: 'из',
      unavailable: 'Недоступно',
    },
    zh: {
      planDetailsHeader: '计划详情',
      planType: '计划类型',
      dailyLimit: '每日限制',
      maxFileSize: '最大文件大小',
      availableStorage: '可用存储',
      storageUsed: '已用存储',
      uploadsRemaining: '剩余上传次数',
      unlimited: '无限制',
      of: '的',
      unavailable: '不可用',
    },
    ja: {
      planDetailsHeader: 'プラン詳細',
      planType: 'プランタイプ',
      dailyLimit: '1日の制限',
      maxFileSize: '最大ファイルサイズ',
      availableStorage: '利用可能なストレージ',
      storageUsed: '使用済みストレージ',
      uploadsRemaining: '残りのアップロード',
      unlimited: '無制限',
      of: 'の',
      unavailable: '利用不可',
    },
    ko: {
      planDetailsHeader: '플랜 세부 정보',
      planType: '플랜 유형',
      dailyLimit: '일일 한도',
      maxFileSize: '최대 파일 크기',
      availableStorage: '사용 가능한 저장 공간',
      storageUsed: '사용된 저장 공간',
      uploadsRemaining: '남은 업로드',
      unlimited: '무제한',
      of: '중',
      unavailable: '사용 불가',
    },
    hi: {
      planDetailsHeader: 'योजना विवरण',
      planType: 'योजना प्रकार',
      dailyLimit: 'दैनिक सीमा',
      maxFileSize: 'अधिकतम फ़ाइल आकार',
      availableStorage: 'उपलब्ध भंडारण',
      storageUsed: 'उपयोग किया गया भंडारण',
      uploadsRemaining: 'शेष अपलोड',
      unlimited: 'असीमित',
      of: 'का',
      unavailable: 'अनुपलब्ध',
    },
    ar: {
      planDetailsHeader: 'تفاصيل الخطة',
      planType: 'نوع الخطة',
      dailyLimit: 'الحد اليومي',
      maxFileSize: 'أقصى حجم للملف',
      availableStorage: 'التخزين المتاح',
      storageUsed: 'التخزين المستخدم',
      uploadsRemaining: 'التحميلات المتبقية',
      unlimited: 'غير محدود',
      of: 'من',
      unavailable: 'غير متاح',
    },
    tr: {
      planDetailsHeader: 'Plan Detayları',
      planType: 'Plan Türü',
      dailyLimit: 'Günlük Limit',
      maxFileSize: 'Maksimum Dosya Boyutu',
      availableStorage: 'Kullanılabilir Depolama',
      storageUsed: 'Kullanılan Depolama',
      uploadsRemaining: 'Kalan Yüklemeler',
      unlimited: 'Sınırsız',
      of: 'nin',
      unavailable: 'Kullanılamaz',
    },
    nl: {
      planDetailsHeader: 'Plangegevens',
      planType: 'Plan Type',
      dailyLimit: 'Dagelijkse Limiet',
      maxFileSize: 'Maximale Bestandsgrootte',
      availableStorage: 'Beschikbare Opslag',
      storageUsed: 'Gebruikte Opslag',
      uploadsRemaining: 'Resterende Uploads',
      unlimited: 'Onbeperkt',
      of: 'van',
      unavailable: 'Niet Beschikbaar',
    },
    sv: {
      planDetailsHeader: 'Plandetaljer',
      planType: 'Plantyp',
      dailyLimit: 'Daglig Gräns',
      maxFileSize: 'Maximal Filstorlek',
      availableStorage: 'Tillgängligt Utrymme',
      storageUsed: 'Använt Utrymme',
      uploadsRemaining: 'Återstående Uppladdningar',
      unlimited: 'Obegränsad',
      of: 'av',
      unavailable: 'Otillgänglig',
    },
    no: {
      planDetailsHeader: 'Plan Detaljer',
      planType: 'Plan Type',
      dailyLimit: 'Daglig Grense',
      maxFileSize: 'Maksimal Filstørrelse',
      availableStorage: 'Tilgjengelig Lagring',
      storageUsed: 'Brukt Lagring',
      uploadsRemaining: 'Gjenværende Opplastinger',
      unlimited: 'Ubegrenset',
      of: 'av',
      unavailable: 'Ikke Tilgjengelig',
    },
    pl: {
      planDetailsHeader: 'Szczegóły Planu',
      planType: 'Typ Planu',
      dailyLimit: 'Limit Dzienny',
      maxFileSize: 'Maksymalny Rozmiar Pliku',
      availableStorage: 'Dostępna Pamięć',
      storageUsed: 'Wykorzystana Pamięć',
      uploadsRemaining: 'Pozostałe Przesłania',
      unlimited: 'Nieograniczony',
      of: 'z',
      unavailable: 'Niedostępny',
    },
    he: {
      planDetailsHeader: 'פרטי התוכנית',
      planType: 'סוג התוכנית',
      dailyLimit: 'מגבלה יומית',
      maxFileSize: 'גודל קובץ מרבי',
      availableStorage: 'אחסון זמין',
      storageUsed: 'אחסון בשימוש',
      uploadsRemaining: 'העלאות נותרות',
      unlimited: 'ללא הגבלה',
      of: 'מתוך',
      unavailable: 'לא זמין',
    },
    fi: {
      planDetailsHeader: 'Suunnitelman Tiedot',
      planType: 'Suunnitelmatyyppi',
      dailyLimit: 'Päivittäinen Rajoitus',
      maxFileSize: 'Tiedoston Suurin Koko',
      availableStorage: 'Saatavilla Oleva Tallennustila',
      storageUsed: 'Käytetty Tallennustila',
      uploadsRemaining: 'Jäljellä Olevat Lataukset',
      unlimited: 'Rajoittamaton',
      of: 'of',
      unavailable: 'Ei Saatavilla',
    },
    el: {
      planDetailsHeader: 'Λεπτομέρειες Σχεδίου',
      planType: 'Τύπος Σχεδίου',
      dailyLimit: 'Ημερήσιο Όριο',
      maxFileSize: 'Μέγιστο Μέγεθος Αρχείου',
      availableStorage: 'Διαθέσιμος Χώρος Αποθήκευσης',
      storageUsed: 'Χρησιμοποιούμενος Χώρος Αποθήκευσης',
      uploadsRemaining: 'Υπολειπόμενες Μεταφορτώσεις',
      unlimited: 'Απεριόριστο',
      of: 'του',
      unavailable: 'Μη Διαθέσιμο',
    },
    da: {
      planDetailsHeader: 'Plandetaljer',
      planType: 'Plantype',
      dailyLimit: 'Daglig Grænse',
      maxFileSize: 'Maksimal Filstørrelse',
      availableStorage: 'Tilgængelig Lagerplads',
      storageUsed: 'Brugt Lagerplads',
      uploadsRemaining: 'Resterende Uploads',
      unlimited: 'Ubegrænset',
      of: 'af',
      unavailable: 'Ikke Tilgængelig',
    },
  };